const forward =
  <T>(effect: (value: T) => unknown) =>
  (value: T) => {
    effect(value);
    return value;
  };

export default forward;
